import { signal, WritableSignal } from '@angular/core';

export abstract class BaseNavService {
  public activeMenuItem: WritableSignal<string | null> = signal(null);
  public isMobileMenuOpen: WritableSignal<boolean> = signal(false);

  public abstract setActiveMenuItem(item: string): void;

  public abstract updateMenuItem(item: string): void;

  public clear(): void {
    this.activeMenuItem.set(null);
  }
}
